import React from 'react';
import { Box, Group, Stack, Text } from '@mantine/core';

export const LOCATION_KEYBOARD_SHORTCUTS: Array<{ keys: string; desc: string }> = [
  { keys: '↑ ↓', desc: 'Move between rows' },
  { keys: '← →', desc: 'Collapse / expand' },
  { keys: 'Enter', desc: 'Rename the selected row' },
  { keys: 'Tab', desc: 'Nest under the row above' },
  { keys: '⇧ Tab', desc: 'Outdent one level' },
  { keys: '⌘ / Ctrl C', desc: 'Copy row and its branch' },
  { keys: '⌘ / Ctrl V', desc: 'Paste inside selection' },
  { keys: '⌘ / Ctrl D', desc: 'Duplicate branch' },
  { keys: '⌘ / Ctrl Z', desc: 'Undo last change' },
  { keys: 'Delete', desc: 'Remove selection' },
  { keys: '/', desc: 'Jump to search' },
  { keys: '?', desc: 'Open this list' },
];

export function LocationKeyboardShortcutsContent() {
  return (
    <Stack gap={0}>
      {LOCATION_KEYBOARD_SHORTCUTS.map(({ keys, desc }) => (
        <Group key={keys} justify="space-between" wrap="nowrap" gap="md" py={4}>
          <Box
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 110,
              padding: '6px 10px',
              borderRadius: 8,
              background: 'var(--mantine-color-default)',
              border: '1px solid var(--mantine-color-default-border)',
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
              fontSize: 11,
              fontWeight: 600,
              color: 'var(--mantine-color-text)',
              flexShrink: 0,
            }}
          >
            {keys}
          </Box>
          <Text size="sm" style={{ flex: 1, minWidth: 0, fontSize: 13 }}>
            {desc}
          </Text>
        </Group>
      ))}
    </Stack>
  );
}
